<div class="flex items-center justify-center min-h-screen bg-gray-50 p-4">
  <div class="w-full max-w-md">
    <vs-card class="shadow-lg">
      <!-- Loading State -->
      <div *ngIf="pageState === PageState.LOADING" class="flex flex-col items-center gap-4 p-8">
        <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
        <p class="text-gray-600">Validating your login link...</p>
      </div>

      <!-- Ready State -->
      <div *ngIf="pageState === PageState.READY" class="flex flex-col items-center gap-6 p-8">
        <div class="flex flex-col items-center gap-3 text-center">
          <div class="rounded-full bg-primary-100 p-4">
            <vs-icon name="check-circle" size="32" class="text-primary-600"></vs-icon>
          </div>
          <h1 class="text-2xl font-semibold text-gray-900">Continue to Portal</h1>
          <p class="text-gray-600">Click the button below to complete your login and access the portal.</p>
          <p class="text-sm text-gray-500">Logging in as <strong>{{ email }}</strong></p>
        </div>

        <button
          vs-button
          theme="primary"
          size="lg"
          class="w-full max-w-xs flex justify-center items-center gap-2"
          (click)="continueToPortal()"
        >
          <vs-icon name="arrow-right"></vs-icon>
          Continue to Portal
        </button>
      </div>

      <!-- Exchanging State -->
      <div *ngIf="pageState === PageState.EXCHANGING" class="flex flex-col items-center gap-4 p-8">
        <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
        <p class="text-gray-600">Completing login...</p>
      </div>

      <!-- Error State -->
      <div *ngIf="pageState === PageState.ERROR" class="flex flex-col gap-6 p-8">
        <div class="flex flex-col items-center gap-3 text-center">
          <div class="rounded-full bg-danger-100 p-4">
            <vs-icon name="alert-circle" size="32" class="text-danger-600"></vs-icon>
          </div>
          <h1 class="text-2xl font-semibold text-gray-900">Login Link Issue</h1>
          <p class="text-gray-600">{{ errorMessage }}</p>
        </div>

        <div class="flex flex-col items-center gap-3">
          <button
            vs-button
            theme="primary"
            size="lg"
            class="w-full max-w-xs flex justify-center items-center gap-2"
            (click)="requestNewLink()"
            *ngIf="email"
          >
            <vs-icon name="mail-01"></vs-icon>
            Send New Login Link
          </button>

          <button
            vs-button
            appearance="outline"
            size="lg"
            class="w-full max-w-xs flex justify-center items-center gap-2"
            (click)="goToLogin()"
          >
            Back to Login
          </button>
        </div>

        <p class="text-xs text-gray-500 text-center">
          Need help? Contact support or try logging in again from the login page.
        </p>
      </div>
    </vs-card>
  </div>
</div>
